import React, { useState } from "react";
import dictionary from "../langs.json";

export const PasswordInput: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = (props) => {
  const [visible, setVisible] = useState(false);
  const locale = navigator.language.toLowerCase().startsWith("en") ? "en" : "ru";
  const text = dictionary[locale].translation;
  return <span className="password-field">
    <input {...props} type={visible ? "text" : "password"} />
    <button type="button" className="password-toggle" disabled={props.disabled}
      aria-label={visible ? text.hide_password : text.show_password}
      aria-pressed={visible} aria-controls={props.id} onClick={() => setVisible(!visible)}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true">
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
        <circle cx="12" cy="12" r="3" />
        {visible && <path d="m3 3 18 18" />}
      </svg>
    </button>
  </span>;
};
